import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ReactNode } from 'react';

interface EmptyExternalProps {
  content?: string | ReactNode;
}

const useStyles = makeStyles({
  wrapper: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: 40,
    boxSizing: 'border-box',
  },
  emptyContainer: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  content: {
    padding: 40,
  },
});

function EmptyExternal({
  content = 'Oops... Something went wrong, we did not find the element you requested',
}: EmptyExternalProps) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Paper className={classes.emptyContainer} elevation={1}>
        <div className={classes.content}>{content}</div>
      </Paper>
    </div>
  );
}

export default EmptyExternal;
